<template>
    <div class="region">
        <!-- <p class="title">开放区域</p> -->
        <!-- <p style=" text-align:center">{{msg}}</p> -->
        <el-row type="flex" class="row-bg honor" justify="center">
            <el-col :span="20" class="main">
                <!-- <el-col class="map"> -->
                    <!-- <img class="banner"
                         src="@/assets/images/ditu.png"> -->
                    <!-- <state /> -->
                <!-- </el-col> -->
                <el-form
                    :model="ruleForm"
                    :rules="rules"
                    :inline="true"
                    ref="ruleForm"
                    label-width="80px"
                    class="demo-ruleForm"
                >
                    <el-form-item class="province" prop="provinceCode">
                        <el-select
                            v-model="ruleForm.provinceCode"
                            clearable
                            @change="queryCity(), clearProvinceChild()"
                            placeholder="省"
                        >
                            <el-option
                                v-for="item in provinceList"
                                :key="item.code"
                                :label="item.name"
                                :value="item.code"
                            >
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item class="city" prop="cityCode">
                        <el-select
                            v-model="ruleForm.cityCode"
                            placeholder="市"
                            clearable
                            @change="queryDistrict(), clearCityChild()"
                        >
                            <el-option
                                v-for="item in cityList"
                                :key="item.code"
                                :label="item.name"
                                :value="item.code"
                            >
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item prop="districtCode" class="district">
                        <el-select
                            v-model="ruleForm.districtCode"
                            clearable
                            placeholder="区"
                        >
                            <el-option
                                v-for="item in districtList"
                                :key="item.code"
                                :label="item.name"
                                :value="item.code"
                            >
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-button class="search" @click="submitForm('ruleForm')"
                        >搜索</el-button
                    >
                </el-form>
                <div class="table">
                    <el-table
                        :data="tableData"
                        :height="701"
                        style="width: 100%"
                    >
                        <el-table-column
                            prop="provinceName"
                            label="省份"
                            align="center"
                        >
                        </el-table-column>
                        <el-table-column
                            prop="cityName"
                            label="城市"
                            align="center"
                        >
                        </el-table-column>
                        <el-table-column
                            prop="domainName"
                            label="区域"
                            align="center"
                        >
                        </el-table-column>
                        <el-table-column
                            prop="remark"
                            label="区域备注"
                            align="center"
                        >
                        </el-table-column>
                        <el-table-column
                            prop="name"
                            label="联系人"
                            align="center"
                        >
                        </el-table-column>
                        <el-table-column
                            prop="tellNum"
                            label="联系电话"
                            align="center"
                        >
                        </el-table-column>
                        <el-table-column label="操作" align="center">
                            <template slot-scope="scope">
                                <el-button
                                    type="text"
                                    @click="application"
                                    v-if="scope.row"
                                    >在线申请</el-button
                                >
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="block">
                    <el-pagination
                        background=""
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="ruleForm.pageIndex"
                        :page-sizes="[10, 20, 50]"
                        :page-size="ruleForm.pageSize"
                        layout="total,sizes,prev, pager, next"
                        :total="ruleForm.total"
                    >
                    </el-pagination>
                </div>
            </el-col>
        </el-row>
    </div>
</template>
<script>
import Bus from "@/utils/bus";
import state from "@/components/map/state";
import { selectopenregion, querycaption } from "@/api/homePage";
export default {
    name: "region",
    components: {
        state
    },
    data() {
        return {
            tableheight: null,
            scrollTop: 1300,
            time: 0,
            scrollState: 0,
            dParams: 1,
            address: "",
            provinceList: [],
            cityList: [],
            districtList: [],
            ruleForm: {
                provinceCode: "",
                cityCode: "",
                districtCode: "",
                data: {
                    province: "",
                    city: "",
                    domain: "",
                    shortname: "",
                    platform: "1"
                },
                pageIndex: 1,
                pageSize: 10,
                total: 1000
            },

            selectedOptions3: [""],
            options: [],
            rules: {
                name: [
                    {
                        required: false,
                        message: "请输入活动名称",
                        trigger: "blur"
                    }
                ],
                areaName: [
                    {
                        required: false,
                        message: "请输入区域名称",
                        trigger: "blur"
                    },
                    {
                        min: 0,
                        max: 20,
                        message: "长度在 0 到 20 个字符",
                        trigger: "blur"
                    }
                ]
            },
            tableData: []
        };
    },
    mounted() {
        window.addEventListener("scroll", this.getScrollTop);
        this.search(1);
    },
    created() {
        this.queryProvince();
        Bus.$on("toregion", data => {
            this.ruleForm.data.province = "";
            this.ruleForm.data.city = "";
            this.ruleForm.data.domain = "";
            this.ruleForm.data.shortname = data;
            this.search(1);
            setTimeout(e => {
                this.gotop();
            }, 500);
        });
    },
    methods: {
        gotop() {
            if (!!window.ActiveXObject || "ActiveXObject" in window) {
                document.documentElement.scrollTop = 1300;
            } else {
                this.toTop();
            }
        },
        toTop() {
            this.scrollState = 1;
            // e.preventDefault();
            let distance =
                document.documentElement.scrollTop ||
                document.body.scrollTop ||
                window.pageYOffset;
            let _this = this;
            this.time = setInterval(function() {
                _this.gotoTop(1300);
            }, 10);
        },
        gotoTop(distance) {
            this.dParams += 20;
            if (distance > 0) {
                distance = distance;
            } else {
                distance = 1300;
            }
            document.documentElement.scrollTop = document.body.scrollTop = window.pageYOffset = distance;
            if (this.scrollTop == 1300) {
                clearInterval(this.time);
                this.dParams = 20;
                this.scrollState = 0;
            }
        },
        getScrollTop() {
            this.scrollTop =
                window.pageYOffset ||
                document.documentElement.scrollTop ||
                document.body.scrollTop;
        },
        search(val) {
            this.ruleForm.pageIndex = val;
            selectopenregion(this.ruleForm)
                .then(res => {
                    if (res.status === 2000) {
                        this.tableData = res.data.rows;
                        this.ruleForm.total = res.data.total;
                        // if (this.tableData.length > 10) {
                        //     this.tableheight = 703;
                        // } else {
                        //     this.tableheight = null;
                        // }
                    }
                })
                .catch(err => {});
        },
        queryProvince() {
            querycaption({ parentCode: "100000" }).then(res => {
                if (res.status === 2000) {
                    this.provinceList = res.data;
                }
            });
        },
        queryCity() {
            querycaption({ parentCode: this.ruleForm.provinceCode }).then(
                res => {
                    if (res.status === 2000) {
                        this.cityList = res.data;
                    }
                }
            );
        },
        queryDistrict() {
            querycaption({ parentCode: this.ruleForm.cityCode }).then(res => {
                if (res.status === 2000) {
                    this.districtList = res.data;
                }
            });
        },
        clearProvinceChild() {
            this.ruleForm.districtCode = "";
            this.ruleForm.cityCode = "";
        },
        clearCityChild() {
            this.ruleForm.districtCode = "";
        },
        handleSizeChange(val) {
            this.ruleForm.pageSize = val;
            this.search(1);
        },
        handleCurrentChange(val) {
            this.search(val);
        },

        seacrr() {
            alert(1111);
        },
        application() {
            this.$router.push({
                path: "/merchants/alliance",
                query: {
                    id: "B1816C74-A73F-2A3C-9DE0-86FAF167ADF1"
                }
            });
        },
        submitForm() {
            this.ruleForm.data.shortname = "";
            this.ruleForm.data.province = this.ruleForm.provinceCode;
            this.ruleForm.data.city = this.ruleForm.cityCode;
            this.ruleForm.data.domain = this.ruleForm.districtCode;
            this.search(1);
        }
    }
};
</script>
<style lang="scss" scoped>
.region {
    padding-bottom: 60px;
    background-color: #fff;
    .honor {
        .main {
            overflow: hidden;
            margin-top: 30px;
            // border: 1px solid #ccc;
            .search {
                background-color: #fabe00;
                color: #fff;
            }
            .el-form--inline .el-form-item {
                // margin-left: 20px;
            }
            .map {
                margin-top: 40px;
                margin-bottom: 10px;
                img {
                    position: relative;
                    left: 50%;
                    transform: translateX(-50%);
                }
                /deep/ #ChinaMap6 {
                    width: 700px;
                    height: 600px;
                    position: relative;
                    left: 50%;
                    transform: translateX(-50%);
                }
            }
            .el-table::before {
                background-color: #fff;
            }
            .table {
                border-left: none;
                /deep/ .el-table {
                    position: relative;
                    left: 50%;
                    transform: translateX(-50%);
                    border: 1px #fff;

                    th {
                        background-color: #e2e2e2;
                        color: #000;
                    }
                    td {
                        border: none;
                        background-color: #f3f3f3;
                        border-bottom: 1px solid #fff;
                    }
                }
            }
            .block {
                margin-top: 20px;
                .el-pagination {
                    text-align: center;
                    margin: 30px 0;
                }
                /deep/ .el-pagination.is-background .el-pager li {
                    border-radius: 15px;
                }
                /deep/ .el-pagination.is-background .btn-prev,
                /deep/ .el-pagination.is-background .btn-next {
                    border-radius: 15px;
                }
            }
        }
    }
}
</style>
